import styled from 'styled-components'

export const ChatWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  overflow: hidden;
`

export const ChatBody = styled.div<{ state?: 'loading' | 'empty' | 'normal' }>`
  overflow-y: auto;
  outline: none;
  padding: 10px;
  height: 300px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: ${props =>
    props.state === 'loading' || props.state === 'empty' ? 'center' : 'flex-start'};
  align-items: ${props =>
    props.state === 'loading' || props.state === 'empty' ? 'center' : 'stretch'};
  gap: 8px;

  /* Анимация цвета текста при loading */
  color: ${props =>
    props.state === 'loading' ? '#1890ff' : props.state === 'empty' ? '#777777' : '#000'};
  animation: ${props =>
    props.state === 'loading' ? 'colorChange 2s infinite ease-in-out' : 'none'};

  @keyframes colorChange {
    0% {
      color: #1890ff;
    }
    50% {
      color: #777777;
    }
    100% {
      color: #1890ff;
    }
  }
`

export const MessageRow = styled.div<{ $left?: boolean }>`
  display: flex;
  justify-content: flex-end;
  flex-direction: ${props => (props.$left ? 'row-reverse' : 'row')};
`

export const MessageText = styled.div<{ $incoming: boolean; $is_read?: boolean }>`
  padding: 4px 10px;
  border: 1px solid #ccc;
  border-radius: ${props => (props.$incoming ? '0 6px 6px 6px' : '6px 0 6px 6px')};
  font-size: 16px;
  background: ${props => (props.$incoming ? '#96f2fa' : '#e0f69f')};
  white-space: pre-wrap;
  box-shadow: ${props => (props.$is_read ? 'none' : '0 0 5px 1px #58c858')};
  transition: box-shadow 0.2s ease;
`

export const MessageDate = styled.div<{ $incoming?: boolean }>`
  text-align: right;
  font-size: 12px;
  margin-top: 4px;
`

export const ChatFooter = styled.div`
  padding: 10px;
  position: relative;
  background-color: #eceff1;
  border-top: 1px solid #ccc;
`

export const ButtonActionWrapper = styled.button`
  margin: 0;
  font-size: 20px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
`

export const LoadingPreloader = styled.div`
  margin: 0;
  font-size: 20px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
`
